(function () {
  const root = document.querySelector("[data-herhe-list-signup]");
  if (!root) return;

  const form = root.querySelector("form.herhe-list-signup__form");
  const statusEl = root.querySelector("[data-herhe-list-signup-status]");
  if (!(form instanceof HTMLFormElement)) return;

  const accountUrl =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/") + "account/register";

  form.addEventListener("submit", async function (event) {
    event.preventDefault();

    const emailInput = form.querySelector('input[type="email"]');
    const firstNameInput = form.querySelector('input[name="contact[first_name]"]');
    const email =
      emailInput instanceof HTMLInputElement ? emailInput.value.trim() : "";
    const firstName =
      firstNameInput instanceof HTMLInputElement
        ? firstNameInput.value.trim()
        : "";

    if (!email) return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
      submitButton.textContent = "Joining…";
    }

    if (statusEl) {
      statusEl.hidden = false;
      statusEl.textContent = "Saving your spot…";
    }

    try {
      await fetch(form.action || "/contact", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(new FormData(form)).toString(),
      });
    } catch {
      // Shopify often redirects; treat as success for UX.
    }

    try {
      window.sessionStorage.setItem(
        "herheListSignup",
        JSON.stringify({ email, firstName, at: Date.now() }),
      );
    } catch {
      // Ignore storage failures.
    }

    if (statusEl) {
      statusEl.textContent =
        "You're in. Create your free account with this email to unlock member pricing.";
    }

    form.style.display = "none";

    const continueLink = document.createElement("a");
    continueLink.className = "herhe-list-signup__cta";
    continueLink.href = accountUrl;
    continueLink.textContent = "Create account";
    continueLink.style.display = "inline-flex";
    continueLink.style.alignItems = "center";
    continueLink.style.justifyContent = "center";
    continueLink.style.textDecoration = "none";
    root.querySelector(".herhe-list-signup__inner")?.appendChild(continueLink);
  });
})();
